import Modalhandler from 'components/shared/modal/modal-handler'
import RequestSendSuccessfully from 'components/shared/modals/request-send-successfully'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

const RequestTour = ({
  handleClick,
  submitButtonTitle,
  className = 'flex items-center lato-bold justify-center btn btn-primary w-full py-3 cursor-pointer hover:bg-secondary-darkorange',
  city,
  isBuildingRequest
}) => {
  const renderModal = (toggle) => {
    const handleToggle = () => {
      toggle()
    }

    return <RequestSendSuccessfully city={city} isBuildingRequest={isBuildingRequest} toggle={handleToggle} />
  }

  return (
    <Modalhandler
      className={className}
      title={submitButtonTitle || 'I’m Interested'}
      onClick={handleClick}
    >
      {({ toggle }) => renderModal(toggle)}
    </Modalhandler>
  )
}

RequestTour.propTypes = {
  title: PropTypes.string,
  spaces: PropTypes.array,
  city: PropTypes.string,
  submitButtonTitle: PropTypes.string,
  className: PropTypes.string,
  selectedSpace: PropTypes.object,
  handleClick: PropTypes.func,
  formName: PropTypes.string,
  isBuildingRequest: PropTypes.bool,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

const mapDispatchToprops = null

export default connect(mapStateToProps, mapDispatchToprops)(RequestTour)
